import { render, staticRenderFns } from "./referral-landing.vue?vue&type=template&id=1a36212f&scoped=true&"
import script from "./referral-landing.vue?vue&type=script&lang=js&"
export * from "./referral-landing.vue?vue&type=script&lang=js&"
import style0 from "./referral-landing.vue?vue&type=style&index=0&id=1a36212f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a36212f",
  null
  
)

export default component.exports